import React from 'react';
import { FormattedMessage } from 'react-intl';
import { SwitchBox } from '../../../molecules/switch-box';
import { SliderBox } from '../../../molecules/slider-box';
import { SelectBox } from '../../../molecules/select-box';
import { ControlBox } from '../../../atoms/control-box';
import { useSelector } from '../../../store/utils';

type Props = {
  showShelliesControl?: boolean;
};

export const SettingsHw = ({ showShelliesControl = false }: Props) => {
  const largeInstallation = useSelector((s) => s.variables.LARGE_INSTALLATION);

  return (
    <>
      <SwitchBox
        title={
          <FormattedMessage
            id="settings.boiler.enabled"
            defaultMessage="Topná patrona nainstalována"
          />
        }
        switchVariableId="HW_INSTALL"
        fullWidth
      />
      {showShelliesControl && (
        <ControlBox
          title={
            <FormattedMessage
              id="settings.boiler.shellies"
              defaultMessage="Bojler je řízen skrze Shelly"
            />
          }
          fullWidth
          visibility={{ variableId: 'HW_SHELLIES' }}
        />
      )}
      <SwitchBox
        title={
          <FormattedMessage
            id="settings.boiler.3phase"
            defaultMessage="Tří-fázová patrona"
          />
        }
        subtitle={
          <FormattedMessage
            id="settings.boiler.3phase.subtitle"
            defaultMessage="Jedno-fázovou patronu zapojte na SSR výstup odpovídající zvolené fázi."
          />
        }
        switchVariableId="PHASE_3_HW"
        visibility={{ variableId: 'HW_INSTALL' }}
        fullWidth
      />
      <SelectBox
        title={
          <FormattedMessage
            id="settings.boiler.phase"
            defaultMessage="Fáze patrony"
          />
        }
        subtitle={
          <FormattedMessage
            id="settings.boiler.phase.subtitle"
            defaultMessage="L1 = SSR výstup 1, L2 = SSR výstup 2, L3 = SSR výstup 3."
          />
        }
        selectVariableId="HW_PHASE"
        options={[
          { value: 0, label: 'L1' },
          { value: 1, label: 'L2' },
          { value: 2, label: 'L3' },
        ]}
        visibility={{
          variableIds: [
            'HW_INSTALL',
            { variableId: 'PHASE_3_HW', reversed: true },
          ],
        }}
        fullWidth
      />
      <SwitchBox
        title={
          <FormattedMessage
            id="settings.boiler.temp_enabled"
            defaultMessage="Teplotní čidlo nainstalováno"
          />
        }
        subtitle={
          <FormattedMessage
            id="settings.boiler.temp_enabled.subtitle"
            defaultMessage="Bojler lze bez čidla využít pouze pro přebytky"
          />
        }
        switchVariableId="HW_TEMP_ENABLED"
        visibility={{ variableId: 'HW_INSTALL' }}
        fullWidth
      />
      <SliderBox
        title={
          <FormattedMessage
            id="settings.boiler.nominal"
            defaultMessage="Nominální příkon"
          />
        }
        subtitle={
          <FormattedMessage
            id="settings.boiler.nominal.subtitle"
            defaultMessage="Nominální příkon pro 1 fázi elektrokotle"
          />
        }
        variableId="HW_EK_NOMINAL"
        visibility={{ variableId: 'HW_INSTALL' }}
        opts={{
          style: 'unit',
          unit: 'kilowatt',
          maximumFractionDigits: 1,
          minimumFractionDigits: 1,
        }}
        step={largeInstallation ? 10 : 0.1}
        min={0.2}
        max={largeInstallation ? 200 : 10}
      />
      <SliderBox
        title={
          <FormattedMessage
            id="settings.boiler.capacity"
            defaultMessage="Objem bojleru"
          />
        }
        subtitle={
          <FormattedMessage
            id="settings.boiler.capacity_sub"
            defaultMessage="Nutné zadat pouze pro spotové obchodování"
          />
        }
        min={20}
        max={largeInstallation ? 10000 : 1000}
        step={largeInstallation ? 50 : 1}
        variableId="HW_CAPACITY"
        visibility={{ variableId: 'HW_INSTALL' }}
        opts={{ style: 'unit', unit: 'litre', maximumFractionDigits: 0 }}
      />
    </>
  );
};
